<template>
  <el-table-column :label="label" :prop="prop" class-name="user-name" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'ユーザー名'
    },
    prop: {
      type: String,
      default: 'user_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.user-name {
      width: 12em;
    }
  }
}
</style>
